import React, { Component, PropTypes } from 'react';
import { Table, Column, AutoSizer } from 'react-virtualized';

const HEADER_HEIGHT = 32;
const ROW_HEIGHT = 40;
const MIN_CELL_WIDTH = 60;

export default class VirtualizedTable extends Component {
    static propTypes = {
        rows: PropTypes.array,
        config: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);

        const config = props.config;
        let minTableWidth = 0;

        this.tableHeader = props.columns.map(({ name, label, minWidth, value, route, style }) => {
            const cellWidth = minWidth || MIN_CELL_WIDTH;

            minTableWidth = minTableWidth + cellWidth;

            return (
                <Column
                    key={name}
                    label={label}
                    cellDataGetter={({ rowData }) => {
                        const cellValue = value ? value(rowData, config) : rowData[name];
                        const styles = style ? style(rowData, config) : void 0;

                        return (
                            <div style={styles} className="virtualized__cell" data-test={name}
                                title={React.isValidElement(cellValue) ? void 0 : cellValue}>
                                {
                                    route ? (
                                        <a href={route(rowData)} target="_blank" >
                                            {cellValue}
                                        </a>
                                    ) : cellValue
                                }
                            </div>
                        );
                    }}
                    cellRenderer={({ cellData }) => cellData}
                    dataKey={name}
                    width={cellWidth}
                />
            );
        });

        this.state = { minTableWidth };
    }

    render() {
        const { minTableWidth } = this.state;
        const { rows } = this.props;

        return (
            <div className="bet-ticker-box__table"  >
                <AutoSizer >
                    {
                        ({ width, height }) =>
                            <Table
                                gridClassName='ticker-bets-container'
                                disableHeader={false}
                                headerHeight={HEADER_HEIGHT}
                                overscanRowCount={8}
                                rowHeight={ROW_HEIGHT}
                                useDynamicRowHeight={true}
                                width={width < minTableWidth ? minTableWidth : width}
                                height={height - HEADER_HEIGHT}
                                rowGetter={({ index }) => this.props.rows[index]}
                                rowCount={rows.length}
                                headerRowRenderer={({ columns, className, style }) => <div role='row' data-test='bet-ticker-header' style={style} className={className}>{columns}</div>}
                                rowRenderer={({ rowData,columns, className, style, index }) => <div aria-rowindex={index} data-test-betid={`id-${rowData?.id}`} style={style} className={className}>{columns}</div>}
                            >
                                {this.tableHeader}
                            </Table>
                    }
                </AutoSizer>
            </div>
        );
    }
}
